"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezoneByName = exports.getLocalTimezone = exports.availableTimezones = void 0;
var MomentTimezone = require("moment-timezone");
var cleanTimezoneName = function (name) { return name.replace(/_/g, ' '); };
exports.availableTimezones = MomentTimezone.tz
    .names()
    .map(function (name) { return ({
    label: cleanTimezoneName(name),
    value: name
}); });
var getLocalTimezone = function () {
    var localTimezone = MomentTimezone.tz.guess();
    return {
        label: cleanTimezoneName(localTimezone),
        value: localTimezone
    };
};
exports.getLocalTimezone = getLocalTimezone;
var getTimezoneByName = function (name) { var _a; return (_a = exports.availableTimezones.find(function (_a) {
    var value = _a.value;
    return value === name;
})) !== null && _a !== void 0 ? _a : (0, exports.getLocalTimezone)(); };
exports.getTimezoneByName = getTimezoneByName;
